var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-login",staticStyle:{"background":"#fdfdfd","height":"100vh"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }